import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'
import ar from './locales/ar.json'
import { DEFAULT_LOCALE, FALLBACK_LOCALE } from './config'

const i18n = createI18n({
  legacy: false, // For Vue 3 Composition API
  locale: DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages: {
    fr,
    ar
  }
})

export default i18n
